<template>
  <v-container>
    <v-row class="justify-center">
      <!-- <exchange :Etype="ExchageType" :showBalance="ShowTotalCash"></exchange> -->

      <v-col cols="12">
        <v-toolbar color="grey lighten-2">
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <cashDisplay
              :isloading="loading"
              :Balance="Allcashes"
            ></cashDisplay>
          </v-toolbar-items>
        </v-toolbar>
      </v-col>
      <v-col cols="6">
        <exchange :showBalance="RefreshBalance"></exchange>
      </v-col>
      <!-- <v-col></v-col> -->
    </v-row>
  </v-container>
</template>
<script>
import exchange from "@/components/HQ/exchange/Exchange.vue";
import cashDisplay from "@/components/util/displayCash.vue";

export default {
  components: { exchange, cashDisplay },
  data() {
    return {
      CashURL: "/Reports/cash/balance",
      loading: false,
      ExchageType: "",
      Allcashes: [],
    };
  },
  methods: {
    GetReq(url, query = { Account: "Cash" }) {
      if (!url) url = this.CashURL;
      // if (!query) query = { from: this.fromDate, to: this.toDate };
      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query,
      });
    },
    RefreshBalance() {
      this.loading = true;
      this.GetReq().then(result => {
        this.Allcashes = result.data;
        this.loading = false;
      });
      // return null;
    },
  },
  created() {
    this.RefreshBalance();
  },
};
</script>
